<div class="modal-header">
    <div class="header-left">
        <h5 class="modal-title">Importar dados geoespaciais</h5>
        @if(_filename()) {
            <span class="file-badge">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                    <polyline points="14 2 14 8 20 8"/>
                </svg>
                <span class="file-name">{{ _filename() }}</span>
            </span>
        }
    </div>
</div>

@if(_inViewStep() !== ImportWizardStep.FEATURES_LIST || (_isMultiFeatured() && _inViewStep() === ImportWizardStep.VALIDATION_CONFIRM)) {
    <div class="stepper-container" [class.multi-featured]="_isMultiFeatured()">
        <app-stepper
            [steps]="steps()"
            [currentStep]="_currentStep()"
            [currentViewStep]="_inViewStep()"
            (stepChange)="onStepChange($event)"
        ></app-stepper>
    </div>
}
@if(_inViewStep() === ImportWizardStep.FEATURES_LIST) {
    <app-import-wizard-geospatial-features-list></app-import-wizard-geospatial-features-list>
}
@if(_inViewStep() === ImportWizardStep.PREVIEW && _state().step >= ImportWizardStep.PREVIEW) {
    <app-import-wizard-geospatial-preview></app-import-wizard-geospatial-preview>
}
@if(_inViewStep() === ImportWizardStep.MAPPING_ADJUSTS && _state().step >= ImportWizardStep.MAPPING_ADJUSTS) {
    <app-import-wizard-geospatial-mapping_adjust></app-import-wizard-geospatial-mapping_adjust>
}
@if(_inViewStep() === ImportWizardStep.VALIDATION_CONFIRM && _state().step >= ImportWizardStep.VALIDATION_CONFIRM) {
    <app-import-wizard-geospatial-confirmation_validation></app-import-wizard-geospatial-confirmation_validation>
}

<app-alert
    title="Sair do mapeamento?"
    message="Foram feitas alterações nesta etapa. Se sair agora, essas mudanças serão perdidas."
    confirmText="Sair sem salvar"
    cancelText="Continuar editando"
    [visible]="isAlertMappingHasChangesOpen()"
    (onConfirmEvent)="handleAlertMappingHasChangesConfirm()"
    (onCancelEvent)="handleAlertMappingHasChangesCancel()"
></app-alert>